var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnLogotext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kn_logotext",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112.198,
    height: 21.242,
    viewBox: "0 0 112.198 21.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M140.245,99.835l-6.983-8.567,4.225-4.225c3.227-3.169,3.7-3.462,5.633-3.7V82.7h-4.988v2.113L129.8,93.028l6.748,8.333a6,6,0,0,0,4.577,2.171h3.227v-.7c-1.643-.235-2.347-1-4.108-2.993",
    transform: "translate(-121.819 -82.7)",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M123.007,99.131c0,2.934.059,3.345,2.817,3.7v.645H116.2v-.645c2.758-.352,2.817-.7,2.817-3.7V86.866c0-2.934-.059-3.169-2.817-3.521V82.7h9.624v.645c-2.758.352-2.817.587-2.817,3.521Z",
    transform: "translate(-116.2 -82.7)",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M168.846,98.371a7.812,7.812,0,1,1-8.861-6.924,7.878,7.878,0,0,1,8.861,6.924m-11.795.528c.352,2.758,2.054,7.8,5.4,7.394,2.523-.352,3.227-3.169,2.758-6.455-.352-2.7-2.054-7.746-5.34-7.335-2.582.352-3.286,3.051-2.817,6.4",
    transform: "translate(-131.525 -86.283)",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M180.859,93.571l5.868-2.171v2.582c1.115-1.467,2.289-2.582,4.577-2.582,2.465,0,4.342,1.643,4.342,5.457v5.985c0,2.934,0,3.345,2.289,3.638v.645h-7.922v-.7c2-.235,2-.645,2-3.638V97.5q0-3.7-2.641-3.7a3.142,3.142,0,0,0-2.641,1.174v7.8c0,2.934,0,3.345,2,3.638v.645H180.8v-.645c2.289-.235,2.289-.645,2.289-3.638V96.975c0-2.641-.176-2.7-2.289-2.758v-.645Z",
    transform: "translate(-142.892 -86.295)",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M211.459,93.571l5.868-2.171v2.582c1.115-1.467,2.289-2.582,4.577-2.582,2.465,0,4.342,1.643,4.342,5.457v5.985c0,2.934,0,3.345,2.289,3.638v.645h-7.922v-.7c2-.235,2-.645,2-3.638V97.5q0-3.7-2.641-3.7a3.142,3.142,0,0,0-2.641,1.174v7.8c0,2.934,0,3.345,2,3.638v.645H211.4v-.645c2.289-.235,2.289-.645,2.289-3.638V96.975c0-2.641-.176-2.7-2.289-2.758v-.645Z",
    transform: "translate(-155.536 -86.295)",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M240.9,99.733c0-4.518,3.286-8.333,7.218-8.333,3.462,0,5.985,2.171,6.22,6.22H244.069v.235c0,4.636,2.523,6.866,5.575,6.866a5.915,5.915,0,0,0,4.342-1.643l.352.293a7.574,7.574,0,0,1-6.514,4.166c-4.46-.117-6.924-3.345-6.924-7.8m3.227-3.286H250.7c-.117-2.758-1.35-3.932-3.051-3.932-2.054,0-3.169,1.526-3.521,3.932",
    transform: "translate(-167.725 -86.295)",
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M278.8,94.217a1.778,1.778,0,0,1-1.936,1.76,1.264,1.264,0,0,1-1.291-.7L274.281,93.1a.831.831,0,0,0-.88-.528c-2.054,0-3.932,1.76-3.932,5.575,0,4.166,2.406,6.514,5.457,6.514a6.682,6.682,0,0,0,3.873-1.408l.352.293c-1.056,1.643-2.758,3.932-5.809,3.932-4.577,0-7.042-3.345-7.042-7.746a8.06,8.06,0,0,1,7.981-8.333c2.465,0,4.518,1.232,4.518,2.817",
    transform: "translate(-178.22 -86.295)",
    fill: "#000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M291.865,99.478V89.62H289.4V88.329h2.523V86.1l3.58-2.7v4.929h3.756V89.62H295.5v9.272c0,2.23.117,3.169,1.819,3.169a3.789,3.789,0,0,0,2.347-.88l.293.235c-1.056,1.291-2.054,2.7-4.342,2.7-2.406,0-3.756-1.174-3.756-4.636",
    transform: "translate(-187.765 -82.989)",
    fill: "#000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnLogotext);
export default __webpack_public_path__ + "static/media/kn_logotext.d8bb77767c9da31db50c661120b5190d.svg";
export { ForwardRef as ReactComponent };